import { render, staticRenderFns } from "./ChooseService.vue?vue&type=template&id=7cd146ba&scoped=true&"
import script from "./ChooseService.vue?vue&type=script&lang=js&"
export * from "./ChooseService.vue?vue&type=script&lang=js&"
import style0 from "./ChooseService.vue?vue&type=style&index=0&id=7cd146ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cd146ba",
  null
  
)

export default component.exports
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QIcon,QDialog,QCard});qInstall(component, 'directives', {ClosePopup});
